module.exports = { "EMAILJS_PUBLIC_KEY": "8kP6o94W24nkf1g-O", "EMAILJS_SERVICE_ID": "service_9o22s1b", "EMAILJS_TEMPLATE_ID": "template_wial51g", "RELEASE_DATE": "2024_11_18_14_13" }
